export default __webpack_public_path__ + "/dist/images/whatsapp-icon.b781e3f29408a4b9cd7b40162e6ab85a.png";